module.exports = __webpack_public_path__ + "static/media/gr_attenuation_2.10e3c820.png";